"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.employeeInTemplateFilter = exports.employeeAppraisalTemplateFilterFunction = void 0;
const lodash_1 = __importDefault(require("lodash"));
const employeeAppraisalTemplateFilterFunction = (input) => (employee) => {
    const emplRoles = (0, lodash_1.default)(input.dataRoles)
        .filter(er => er.Employee === employee)
        .map(er => er.Role)
        .value();
    const jobClasses = (0, lodash_1.default)(input.dataJobs)
        .filter(j => j.Employee === employee)
        .filter(j => j.Active == 1)
        .map(j => j.Classification)
        .value();
    return (lodash_1.default.concat(lodash_1.default.intersection(emplRoles, input.roles), lodash_1.default.intersection(jobClasses, input.classifications)).length > 0);
};
exports.employeeAppraisalTemplateFilterFunction = employeeAppraisalTemplateFilterFunction;
const employeeInTemplateFilter = (dataJobs, dataRoles, classifications, roles, employee) => (0, exports.employeeAppraisalTemplateFilterFunction)({
    dataRoles,
    dataJobs,
    classifications,
    roles,
})(employee);
exports.employeeInTemplateFilter = employeeInTemplateFilter;
//# sourceMappingURL=hr-util.js.map